let currentStore;

function checkForStore() {
  if (!currentStore) {
    throw new Error('Tried to get store, but there is no store!');
  }
}

export default {
  get() {
    checkForStore();
    return currentStore;
  },

  set(store) {
    currentStore = store;
  },

  getState() {
    checkForStore();
    return currentStore.getState();
  },

  dispatch(...args) {
    checkForStore();
    return currentStore.dispatch(...args);
  },
};
